'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { List } from 'immutable';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import styled from 'styled-components';
import I18n from 'I18n';
import { connect } from 'react-redux';
import get from 'transmute/get';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UICardSection from 'UIComponents/card/UICardSection';
import H4 from 'UIComponents/elements/headings/H4';
import LegalConsentInputs from 'MeetingsLib/components/input/LegalConsentInputs';
import StepButtonsFooter from 'MeetingsLib/components/page/StepButtonsFooter';
import Branding from 'MeetingsBase/models/Branding';
import LegalConsentOptions from 'MeetingsBase/models/LegalConsentOptions';
import { getStagedLegalConsentResponses, getAllStagedRequiredConsentCollected } from 'MeetingsLib/selectors/LegalConsentFormSelectors';
import { getRecaptchaEnabled } from '../../selectors/BookInfoSelectors';
import { getCustomParams, getOffline as getOfflineSelector, getIsLegitimateInterest } from 'MeetingsLib/selectors/BookInfoSelectors';
import * as FormActions from 'MeetingsLib/redux/actions/FormActions';
import { HiddenAriaStatus } from 'MeetingsLib/components/decorative/HiddenAriaStatus';
var FormBody = styled.div.withConfig({
  displayName: "LegalConsentForm__FormBody",
  componentId: "sc-1s31nsh-0"
})(["max-height:80%;flex-shrink:1;overflow-y:scroll;overflow-x:hidden;"]);
var LegalConsentForm = createReactClass({
  displayName: "LegalConsentForm",
  propTypes: {
    // passed
    branding: PropTypes.instanceOf(Branding).isRequired,
    submittingMeeting: PropTypes.bool,
    goToPreviousStep: PropTypes.func.isRequired,
    // loaded
    legalConsentOptions: PropTypes.instanceOf(LegalConsentOptions).isRequired,
    stagedLegalConsentResponses: PropTypes.instanceOf(List),
    setGivenConsent: PropTypes.func.isRequired,
    resetConsentResponses: PropTypes.func.isRequired,
    submitConsentResponses: PropTypes.func.isRequired,
    allRequiredConsentCollected: PropTypes.bool.isRequired,
    offline: PropTypes.bool,
    isLegitimateInterest: PropTypes.bool.isRequired,
    dateTime: PropTypes.number.isRequired,
    userTimezone: PropTypes.string.isRequired,
    recaptchaEnabled: PropTypes.bool
  },
  handleGoBack: function handleGoBack() {
    var _this$props = this.props,
        resetConsentResponses = _this$props.resetConsentResponses,
        goToPreviousStep = _this$props.goToPreviousStep;
    resetConsentResponses();
    goToPreviousStep();
  },
  handleSubmit: function handleSubmit() {
    var _this$props2 = this.props,
        stagedLegalConsentResponses = _this$props2.stagedLegalConsentResponses,
        submitConsentResponses = _this$props2.submitConsentResponses;
    submitConsentResponses(stagedLegalConsentResponses);
  },
  renderAccessibleMessage: function renderAccessibleMessage() {
    var _this$props3 = this.props,
        companyName = _this$props3.branding.companyName,
        dateTime = _this$props3.dateTime,
        userTimezone = _this$props3.userTimezone;
    var selectedDate = I18n.moment(dateTime).tz(userTimezone).format('LLLL');

    var accessibleMessage = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "accessible.privacyStatusNoCompany",
      options: {
        selectedDate: selectedDate
      }
    });

    if (companyName) {
      accessibleMessage = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "accessible.privacyStatus",
        options: {
          domain: companyName,
          selectedDate: selectedDate
        }
      });
    }

    return accessibleMessage;
  },
  renderHeader: function renderHeader() {
    return /*#__PURE__*/_jsxs(H4, {
      tabIndex: 1,
      className: "p-x-10 p-top-10 m-bottom-5",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "dataPrivacy"
      }), /*#__PURE__*/_jsx(HiddenAriaStatus, {
        role: "status",
        "aria-live": "polite",
        children: this.renderAccessibleMessage()
      })]
    });
  },
  renderFormButtons: function renderFormButtons() {
    var _this$props4 = this.props,
        branding = _this$props4.branding,
        submittingMeeting = _this$props4.submittingMeeting,
        allRequiredConsentCollected = _this$props4.allRequiredConsentCollected,
        offline = _this$props4.offline,
        isLegitimateInterest = _this$props4.isLegitimateInterest;
    return /*#__PURE__*/_jsx(StepButtonsFooter, {
      branding: branding,
      submittingMeeting: submittingMeeting,
      canProceed: isLegitimateInterest || allRequiredConsentCollected,
      tooltipTitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "buttons.tooltip.missingConsent"
      }),
      isLastStep: true,
      goToPreviousStep: this.handleGoBack,
      goToNextStep: this.handleSubmit,
      offline: offline
    });
  },
  renderLegalConsentInputs: function renderLegalConsentInputs() {
    var _this$props5 = this.props,
        legalConsentOptions = _this$props5.legalConsentOptions,
        stagedLegalConsentResponses = _this$props5.stagedLegalConsentResponses,
        setGivenConsent = _this$props5.setGivenConsent,
        recaptchaEnabled = _this$props5.recaptchaEnabled;
    return /*#__PURE__*/_jsx(FormBody, {
      children: /*#__PURE__*/_jsx(LegalConsentInputs, {
        legalConsentResponses: stagedLegalConsentResponses,
        legalConsentOptions: legalConsentOptions,
        setGivenConsent: setGivenConsent,
        recaptchaEnabled: recaptchaEnabled
      })
    });
  },
  render: function render() {
    return /*#__PURE__*/_jsx(UICardWrapper, {
      className: "flex-column min-height-0",
      children: /*#__PURE__*/_jsxs(UICardSection, {
        className: "p-all-0 flex-column min-height-0",
        children: [this.renderHeader(), this.renderLegalConsentInputs(), this.renderFormButtons()]
      })
    });
  }
});
export default connect(function (state) {
  return {
    allRequiredConsentCollected: getAllStagedRequiredConsentCollected(state),
    legalConsentOptions: get('legalConsentOptions', getCustomParams(state)),
    recaptchaEnabled: getRecaptchaEnabled(state),
    stagedLegalConsentResponses: getStagedLegalConsentResponses(state),
    offline: getOfflineSelector(state),
    isLegitimateInterest: getIsLegitimateInterest(state),
    userTimezone: state.userTimezone
  };
}, Object.assign({}, FormActions))(LegalConsentForm);